import React, { useState, useCallback } from 'react';
import { db, auth, getCollectionName } from './firebase.js';
import { collection, addDoc, serverTimestamp } from './firestore-compat';

const SCREENS = [
  { key: 'paciente', label: 'Dados do Paciente', gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' },
  { key: 'pad', label: 'PAD (Plano de Atenção Domiciliar)', gradient: 'linear-gradient(135deg, #38a169 0%, #2f855a 100%)' },
  { key: 'exames', label: 'Exames', gradient: 'linear-gradient(135deg, #e67e22 0%, #d35400 100%)' },
  { key: 'remocoes', label: 'Remoções', gradient: 'linear-gradient(135deg, #e53e3e 0%, #c53030 100%)' },
  { key: 'mobiliario', label: 'Mobiliário', gradient: 'linear-gradient(135deg, #805ad5 0%, #6b46c1 100%)' },
  { key: 'gases', label: 'Gases Medicinais', gradient: 'linear-gradient(135deg, #3182ce 0%, #2b6cb0 100%)' },
  { key: 'equipamentos', label: 'Equipamentos', gradient: 'linear-gradient(135deg, #d69e2e 0%, #b7791f 100%)' },
  { key: 'prontuario', label: 'Prontuário', gradient: 'linear-gradient(135deg, #319795 0%, #2c7a7b 100%)' },
  { key: 'farmacia', label: 'Farmácia', gradient: 'linear-gradient(135deg, #dd6b20 0%, #c05621 100%)' },
  { key: 'logistica',   label: 'Logística',   gradient: 'linear-gradient(135deg, #667eea 0%, #38a169 100%)' },
  { key: 'suprimentos', label: 'Suprimentos', gradient: 'linear-gradient(135deg, #319795 0%, #2c7a7b 100%)' },
];

const PAD_DISCIPLINES = [
  { key: 'fisioterapia', label: 'Fisioterapia', short: 'Fisio' },
  { key: 'fonoaudiologia', label: 'Fonoaudiologia', short: 'Fono' },
  { key: 'nutricao', label: 'Nutrição', short: 'Nutri' },
  { key: 'tecEnfermagem', label: 'Técnico de Enfermagem', short: 'Téc. Enf.' },
  { key: 'enfermeiro', label: 'Enfermeiro', short: 'Enfermeiro' },
  { key: 'medico', label: 'Médico', short: 'Médico' },
  { key: 'psicologo', label: 'Psicólogo', short: 'Psicólogo' },
  { key: 'terapeutaOcupacional', label: 'Terapeuta Ocupacional', short: 'TO' },
];

const FILIAL_OPTIONS = ['Homebaby', 'Vitalcare'];
const CLASSIFICACAO_OPTIONS = ['ID', 'AD', 'Pontual'];
const CATEGORIA_OPTIONS = [
  'ID 6h', 'ID 12h', 'ID 24h', 'ID 24h com VM',
  'Pontual Curativo', 'Pontual Medicamento', 'Pontual Curativo/Medicamento',
  'Pontual Procedimento', 'Pontual Antibioticoterapia',
  'Terapias e Curativo', 'Terapias e Medicamentos', 'Terapias/ Curativo/ Medicamento',
  'Terapias e Procedimentos', 'Terapias e Antibioticoterapia', 'Terapias e Equipamentos',
  'Terapias', 'Equipamentos',
  'Enfermagem Exclusiva 6h', 'Enfermagem Exclusiva 12h', 'Enfermagem Exclusiva 24h'
];
const TIPO_OPTIONS = ['Novo', 'Reimplantação'];
const TIPO_OCORRENCIA_OPTIONS = ['Hospitalização', 'Implantação'];
const CONVENIO_OPTIONS = [
  'ASSIM SAÚDE',
  'CAURJ',
  'FIO SAÚDE',
  'GOLDEN CROSS',
  'HB - AMIL',
  'HB - BRADESCO',
  'HB - GNDI',
  'HB - UNIMED - FERJ',
  'HB - UNIMED ARARUAMA',
  'HB - UNIMED BRASIL',
  'HB - UNIMED C SOL',
  'HB - UNIMED C VERDE',
  'HB - UNIMED CAMPOS',
  'HB - UNIMED LF',
  'HB - UNIMED NI',
  'HB - UNIMED NOROE FL',
  'HB - UNIMED NORTE FL',
  'HB - UNIMED PETROPOL',
  'HB - UNIMED SEGUROS',
  'HB - UNIMED SERRANA',
  'HB - UNIMED TRES RIO',
  'HB - UNIMED V REDOND',
  'HB - UNIMED C FRIO',
  'HB - UNIMED M VALENÇA',
  'HB - VALE S.A',
  'HS - POSTAL SAUDE',
  'HS - PREVENT SENIOR',
  'HS - SELECT SAUDE',
  'HS - UNIMED ARARUAMA',
  'HS - UNIMED BRASIL',
  'HS - UNIMED C FRIO',
  'HS - UNIMED C SOL',
  'HS - UNIMED C VERDE',
  'HS - UNIMED CAMPOS',
  'HS - UNIMED FERJ',
  'HS - UNIMED LF',
  'HS - UNIMED M VALENÇA',
  'HS - UNIMED NI',
  'HS - UNIMED NOROE FL',
  'HS - UNIMED NORTE FL',
  'HS - UNIMED PETROPOL',
  'HS - UNIMED SEGUROS',
  'HS - UNIMED SERRANA',
  'HS - UNIMED TRES RIO',
  'HS - UNIMED V REDOND',
  'HS - VALE S.A.',
  'KLINI SAÚDE',
  'PETROBRAS SA',
  'SULAMERICA',
  'UNIMED BRASIL TREINA',
  'UNIMED LESTE FLUMINE',
];
const FREQUENCIA_OPTIONS = [
  'Anual', 'Avulsa', 'Bimestral', 'Diária', 'Dias alternados', 'Mensal', 'Quinzenal',
  'Trimestral', '1x semana', '2x dia', '2x semana', '3x dia', '3x semana',
  '3x semana (-SD)', '4x semana', '5x semana', '6x semana',
];

const PAD_SUBESPECIALIDADES = {
  fisioterapia: [
    'Fisioterapeuta','Fisioterapeuta Bobath','Fisioterapeuta Cuevas Medke',
    'Fisioterapeuta Método AME','Fisioterapeuta Método TR3','Fisioterapeuta Neurológica',
    'Fisioterapeuta Pediasuit','Fisioterapeuta RPG','Fisioterapeuta RTA',
    'Fisioterapeuta Urologia','Fisioterapia Motora','Fisioterapia Respiratória',
  ],
  fonoaudiologia: [
    'Fonoaudiologo(a)','Fonoaudiologo(a) Bobath','Fonoaudiologo(a) Laserterapia',
  ],
  psicologo: [
    'Psicologo(a)','Psicomotricidade','Psicopedagoga','Psicoterapia',
  ],
  terapeutaOcupacional: [
    'Terapeuta Ocupacional','Terapia Ocup. Integra Sensorial','Terapia Ocupacional Bobath',
  ],
};

const AREA_SCREENS_KEYS = ['exames', 'remocoes', 'mobiliario', 'gases', 'equipamentos', 'prontuario', 'farmacia', 'logistica', 'suprimentos'];

function ToggleSwitch({ value, onChange, label }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
      <div
        onClick={() => onChange(!value)}
        style={{
          width: 52,
          height: 28,
          borderRadius: 14,
          background: value ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#cbd5e0',
          cursor: 'pointer',
          position: 'relative',
          transition: 'background 0.25s ease',
          flexShrink: 0,
          boxShadow: value ? '0 2px 8px rgba(102,126,234,0.35)' : '0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div
          style={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            background: '#fff',
            position: 'absolute',
            top: 3,
            left: value ? 27 : 3,
            transition: 'left 0.25s ease',
            boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
          }}
        />
      </div>
      {label && (
        <span style={{ fontSize: 15, fontWeight: 600, color: '#2d3748', fontFamily: 'Inter, sans-serif' }}>
          {label}
        </span>
      )}
    </div>
  );
}

export default function WizardOcorrencia({ onClose }) {
  const [currentScreen, setCurrentScreen] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [opacity, setOpacity] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Screen 1 — Dados do Paciente
  const [paciente, setPaciente] = useState({
    filial: '',
    nomeCompleto: '',
    dataNascimento: '',
    convenio: '',
    numIW: '',
    classificacao: '',
    categoria: '',
    possuiLiminar: false,
    tipo: '',
    tipoOcorrencia: '',
    observacoes: '',
  });

  // Screen 2 — PAD
  const [pad, setPad] = useState(() => {
    const initial = {};
    PAD_DISCIPLINES.forEach((d) => {
      initial[d.key] = { enabled: false, frequencia: '', subEspecialidade: '' };
    });
    return initial;
  });

  // Screens 3-10 — Areas
  const [areas, setAreas] = useState(() => {
    const initial = {};
    AREA_SCREENS_KEYS.forEach((key) => {
      if (key === 'prontuario') {
        initial[key] = {
          enabled: false,
          pastaFixa: false,
          guiaAutorizacao: false,
          prescricaoMedica: false,
          tcle: false,
          cronograma: false,
          admissao: false,
          observacoes: '',
        };
      } else {
        initial[key] = { enabled: false, campo1: '', campo2: '', campo3: '', observacoes: '' };
      }
    });
    return initial;
  });

  const userName = auth.currentUser?.displayName || 'Usuário';
  const userUid = auth.currentUser?.uid || '';

  const updatePaciente = useCallback((field, value) => {
    setPaciente((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => {
      const next = { ...prev };
      delete next[field];
      return next;
    });
  }, []);

  const updatePad = useCallback((key, field, value) => {
    setPad((prev) => ({
      ...prev,
      [key]: { ...prev[key], [field]: value },
    }));
  }, []);

  const updateArea = useCallback((areaKey, field, value) => {
    setAreas((prev) => ({
      ...prev,
      [areaKey]: { ...prev[areaKey], [field]: value },
    }));
  }, []);

  const navigateTo = useCallback((targetScreen) => {
    if (animating) return;
    setAnimating(true);
    setOpacity(0);
    setTimeout(() => {
      setCurrentScreen(targetScreen);
      setOpacity(1);
      setAnimating(false);
    }, 200);
  }, [animating]);

  const validateScreen1 = useCallback(() => {
    const required = [
      'filial', 'nomeCompleto', 'dataNascimento', 'convenio',
      'numIW', 'classificacao', 'categoria', 'tipoOcorrencia',
      // 'Modo de Entrada' só obrigatório para Implantação
      ...(paciente.tipoOcorrencia === 'Implantação' ? ['tipo'] : []),
    ];
    const newErrors = {};
    required.forEach((field) => {
      if (!paciente[field] || (typeof paciente[field] === 'string' && !paciente[field].trim())) {
        newErrors[field] = true;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [paciente]);

  const handleNext = useCallback(() => {
    if (currentScreen === 0 && !validateScreen1()) {
      return;
    }
    if (currentScreen < SCREENS.length - 1) {
      navigateTo(currentScreen + 1);
    }
  }, [currentScreen, navigateTo, validateScreen1]);

  const handleBack = useCallback(() => {
    if (currentScreen === 0) {
      if (onClose) onClose();
      else window.location.href = '/gestao-ocorrencias';
      return;
    }
    navigateTo(currentScreen - 1);
  }, [currentScreen, navigateTo, onClose]);

  const handleSubmit = useCallback(async () => {
    if (!validateScreen1()) {
      navigateTo(0);
      return;
    }
    setSubmitting(true);
    try {
      const ocorrenciaData = {
        paciente: {
          filial: paciente.filial,
          nomeCompleto: paciente.nomeCompleto.trim(),
          dataNascimento: paciente.dataNascimento,
          convenio: paciente.convenio,
          numAtendimento: paciente.numIW.trim(),
          numIW: paciente.numIW.trim(),
          classificacao: paciente.classificacao,
          categoria: paciente.categoria,
          possuiLiminar: paciente.possuiLiminar,
          tipo: paciente.tipo,
          tipoOcorrencia: paciente.tipoOcorrencia,
          observacoes: paciente.observacoes.trim(),
        },
        pad: { ...pad },
        tipo: paciente.tipoOcorrencia === 'Hospitalização' ? 'hospitalizacao' : 'implantacao',
        wizardData: { ...areas },
        status: 'aberto',
        criadoPorNome: userName,
        criadoPorUid: userUid,
        dataAbertura: serverTimestamp(),
        dataAtualizacao: serverTimestamp(),
      };

      const colName = getCollectionName('ocorrencias_v2');
      const ocorrenciaRef = await addDoc(collection(db, colName), ocorrenciaData);

      const tarefasCol = collection(db, colName, ocorrenciaRef.id, 'tarefas');
      let ordem = 1;

      // Create PAD tasks
      for (const discipline of PAD_DISCIPLINES) {
        const padEntry = pad[discipline.key];
        if (padEntry.enabled) {
          await addDoc(tarefasCol, {
            area: `PAD - ${discipline.label}`,
            areaPai: 'PAD',
            status: 'pendente',
            prioridade: 'Média',
            dataAbertura: serverTimestamp(),
            dataConclusao: null,
            ordem: ordem++,
            descricao: padEntry.frequencia || '',
            subEspecialidade: padEntry.subEspecialidade || '',
            frequencia: padEntry.frequencia || '',
            responsavelNome: '',
            responsavelUid: '',
            criadoPorNome: userName,
            criadoPorUid: userUid,
          });
        }
      }

      // Create Area tasks
      const PRONTUARIO_ITENS = [
        { key: 'pastaFixa',        label: 'Pasta Fixa' },
        { key: 'guiaAutorizacao',  label: 'Guia / Autorização' },
        { key: 'prescricaoMedica', label: 'Prescrição Médica' },
        { key: 'tcle',             label: 'TCLE' },
        { key: 'cronograma',       label: 'Cronograma de Visitas' },
        { key: 'admissao',         label: 'Admissão / Alta Hospitalar' },
      ];
      for (const areaKey of AREA_SCREENS_KEYS) {
        const areaData = areas[areaKey];
        if (!areaData.enabled) continue;
        const screenInfo = SCREENS.find((s) => s.key === areaKey);
        const areaName = screenInfo ? screenInfo.label : areaKey;

        if (areaKey === 'prontuario') {
          const itensSelecionados = PRONTUARIO_ITENS.filter(({ key }) => areaData[key]).map(({ label }) => label);
          const desc = [
            itensSelecionados.join(' | '),
            areaData.observacoes?.trim() ? `Obs: ${areaData.observacoes.trim()}` : ''
          ].filter(Boolean).join(' | ');

          await addDoc(tarefasCol, {
            area: 'Prontuário',
            areaPai: null,
            status: 'pendente',
            prioridade: 'Média',
            dataAbertura: serverTimestamp(),
            dataConclusao: null,
            ordem: ordem++,
            descricao: desc,
            responsavelNome: '',
            responsavelUid: '',
            criadoPorNome: userName,
            criadoPorUid: userUid,
          });
        } else {
          const descParts = [];
          if (areaData.campo1?.trim()) descParts.push(areaData.campo1.trim());
          if (areaData.campo2?.trim()) descParts.push(areaData.campo2.trim());
          if (areaData.campo3?.trim()) descParts.push(areaData.campo3.trim());
          if (areaData.observacoes?.trim()) descParts.push(`Obs: ${areaData.observacoes.trim()}`);

          await addDoc(tarefasCol, {
            area: areaName,
            areaPai: null,
            status: 'pendente',
            prioridade: 'Média',
            dataAbertura: serverTimestamp(),
            dataConclusao: null,
            ordem: ordem++,
            descricao: descParts.join(' | '),
            responsavelNome: '',
            responsavelUid: '',
            criadoPorNome: userName,
            criadoPorUid: userUid,
          });
        }
      }

      if (onClose) onClose();
      else window.location.href = '/gestao-ocorrencias';
    } catch (err) {
      console.error('Erro ao criar ocorrência:', err);
      alert('Erro ao criar ocorrência. Tente novamente.');
      setSubmitting(false);
    }
  }, [paciente, pad, areas, userName, userUid, navigateTo, validateScreen1]);

  const isLastScreen = currentScreen === SCREENS.length - 1;
  const screen = SCREENS[currentScreen];

  // ─── Styles ──────────────────────────────────────────────────────────────────
  const styles = {
    page: {
      minHeight: '100vh',
      background: '#f7fafc',
      fontFamily: 'Inter, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: 32,
      paddingBottom: 120,
    },
    card: {
      background: '#fff',
      borderRadius: 20,
      boxShadow: '0 8px 32px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)',
      maxWidth: 700,
      width: '100%',
      margin: '0 auto',
      overflow: 'hidden',
      opacity: opacity,
      transition: 'opacity 0.2s ease',
    },
    headerBar: {
      background: screen.gradient,
      padding: '24px 32px',
      color: '#fff',
    },
    headerTitle: {
      fontSize: 22,
      fontWeight: 700,
      margin: 0,
      letterSpacing: '-0.3px',
    },
    headerSubtitle: {
      fontSize: 13,
      fontWeight: 500,
      marginTop: 4,
      opacity: 0.85,
    },
    body: {
      padding: 32,
    },
    label: {
      display: 'block',
      fontSize: 14,
      fontWeight: 600,
      color: '#2d3748',
      marginBottom: 6,
      marginTop: 18,
    },
    labelRequired: {
      color: '#e53e3e',
      marginLeft: 2,
    },
    input: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: 10,
      border: '1.5px solid #e2e8f0',
      fontSize: 15,
      fontFamily: 'Inter, sans-serif',
      color: '#2d3748',
      background: '#fff',
      outline: 'none',
      transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
      boxSizing: 'border-box',
    },
    inputError: {
      borderColor: '#e53e3e',
      boxShadow: '0 0 0 3px rgba(229,62,62,0.12)',
    },
    inputFocused: {
      borderColor: '#667eea',
      boxShadow: '0 0 0 3px rgba(102,126,234,0.15)',
    },
    select: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: 10,
      border: '1.5px solid #e2e8f0',
      fontSize: 15,
      fontFamily: 'Inter, sans-serif',
      color: '#2d3748',
      background: '#fff',
      outline: 'none',
      cursor: 'pointer',
      boxSizing: 'border-box',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23718096' d='M6 8.825L1.175 4 2.238 2.938 6 6.7 9.763 2.937 10.825 4z'/%3E%3C/svg%3E")`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'right 14px center',
      paddingRight: 36,
    },
    textarea: {
      width: '100%',
      padding: '12px 14px',
      borderRadius: 10,
      border: '1.5px solid #e2e8f0',
      fontSize: 15,
      fontFamily: 'Inter, sans-serif',
      color: '#2d3748',
      background: '#fff',
      outline: 'none',
      resize: 'vertical',
      minHeight: 80,
      boxSizing: 'border-box',
    },
    pinkLabel: {
      display: 'block',
      fontSize: 14,
      fontWeight: 600,
      color: '#ec4899',
      marginBottom: 6,
      marginTop: 18,
    },
    bottomBar: {
      background: '#fff',
      borderTop: '1px solid #e2e8f0',
      padding: '14px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0,
    },
    btnBack: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '10px 20px',
      borderRadius: 10,
      border: '1.5px solid #e2e8f0',
      background: '#fff',
      color: '#475569',
      fontSize: 15,
      fontWeight: 600,
      fontFamily: 'Inter, sans-serif',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    btnNext: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '10px 24px',
      borderRadius: 10,
      border: 'none',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: '#fff',
      fontSize: 15,
      fontWeight: 600,
      fontFamily: 'Inter, sans-serif',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 4px 14px rgba(102,126,234,0.35)',
    },
    btnSubmit: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      padding: '10px 28px',
      borderRadius: 10,
      border: 'none',
      background: 'linear-gradient(135deg, #38a169 0%, #2f855a 100%)',
      color: '#fff',
      fontSize: 15,
      fontWeight: 700,
      fontFamily: 'Inter, sans-serif',
      cursor: submitting ? 'not-allowed' : 'pointer',
      transition: 'all 0.2s ease',
      boxShadow: '0 4px 14px rgba(56,161,105,0.35)',
      opacity: submitting ? 0.7 : 1,
    },
    dots: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    errorMsg: {
      fontSize: 12,
      color: '#e53e3e',
      marginTop: 4,
    },
    sectionDivider: {
      borderTop: '1px solid #edf2f7',
      margin: '24px 0 16px 0',
    },
    disciplineCard: {
      background: '#f7fafc',
      borderRadius: 14,
      padding: '16px 20px',
      marginBottom: 12,
      border: '1px solid #edf2f7',
    },
  };

  // ─── Input Focus Handling ────────────────────────────────────────────────────
  const [focusedField, setFocusedField] = useState(null);

  const getInputStyle = (fieldName) => ({
    ...styles.input,
    ...(errors[fieldName] ? styles.inputError : {}),
    ...(focusedField === fieldName ? styles.inputFocused : {}),
  });

  const getSelectStyle = (fieldName) => ({
    ...styles.select,
    ...(errors[fieldName] ? styles.inputError : {}),
    ...(focusedField === fieldName ? styles.inputFocused : {}),
  });

  // ─── Render Screen 1: Dados do Paciente ──────────────────────────────────────
  const renderScreen1 = () => (
    <div>
      <label style={styles.label}>
        Filial<span style={styles.labelRequired}>*</span>
      </label>
      <select
        value={paciente.filial}
        onChange={(e) => updatePaciente('filial', e.target.value)}
        onFocus={() => setFocusedField('filial')}
        onBlur={() => setFocusedField(null)}
        style={getSelectStyle('filial')}
      >
        <option value="">Selecione a filial</option>
        {FILIAL_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {errors.filial && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Nome Completo<span style={styles.labelRequired}>*</span>
      </label>
      <input
        type="text"
        value={paciente.nomeCompleto}
        onChange={(e) => updatePaciente('nomeCompleto', e.target.value)}
        onFocus={() => setFocusedField('nomeCompleto')}
        onBlur={() => setFocusedField(null)}
        placeholder="Nome completo do paciente"
        style={getInputStyle('nomeCompleto')}
      />
      {errors.nomeCompleto && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Data de Nascimento<span style={styles.labelRequired}>*</span>
      </label>
      <input
        type="date"
        value={paciente.dataNascimento}
        onChange={(e) => updatePaciente('dataNascimento', e.target.value)}
        onFocus={() => setFocusedField('dataNascimento')}
        onBlur={() => setFocusedField(null)}
        style={getInputStyle('dataNascimento')}
      />
      {errors.dataNascimento && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Convênio<span style={styles.labelRequired}>*</span>
      </label>
      <select
        value={paciente.convenio}
        onChange={(e) => updatePaciente('convenio', e.target.value)}
        onFocus={() => setFocusedField('convenio')}
        onBlur={() => setFocusedField(null)}
        style={getSelectStyle('convenio')}
      >
        <option value="">Selecione o convênio</option>
        {CONVENIO_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {errors.convenio && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Nº IW / Atendimento<span style={styles.labelRequired}>*</span>
      </label>
      <input
        type="text"
        value={paciente.numIW}
        onChange={(e) => updatePaciente('numIW', e.target.value)}
        onFocus={() => setFocusedField('numIW')}
        onBlur={() => setFocusedField(null)}
        placeholder="Número IW / Atendimento"
        style={getInputStyle('numIW')}
      />
      {errors.numIW && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Classificação do Atendimento<span style={styles.labelRequired}>*</span>
      </label>
      <select
        value={paciente.classificacao}
        onChange={(e) => updatePaciente('classificacao', e.target.value)}
        onFocus={() => setFocusedField('classificacao')}
        onBlur={() => setFocusedField(null)}
        style={getSelectStyle('classificacao')}
      >
        <option value="">Selecione a classificação</option>
        {CLASSIFICACAO_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {errors.classificacao && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Categoria<span style={styles.labelRequired}>*</span>
      </label>
      <select
        value={paciente.categoria}
        onChange={(e) => updatePaciente('categoria', e.target.value)}
        onFocus={() => setFocusedField('categoria')}
        onBlur={() => setFocusedField(null)}
        style={getSelectStyle('categoria')}
      >
        <option value="">Selecione a categoria</option>
        {CATEGORIA_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {errors.categoria && <div style={styles.errorMsg}>Campo obrigatório</div>}

      <label style={styles.label}>
        Possui Liminar?<span style={styles.labelRequired}>*</span>
      </label>
      <div style={{ display: 'flex', gap: 12, marginTop: 4 }}>
        <button
          type="button"
          onClick={() => updatePaciente('possuiLiminar', true)}
          style={{
            padding: '10px 28px',
            borderRadius: 10,
            border: paciente.possuiLiminar === true ? 'none' : '1.5px solid #e2e8f0',
            background: paciente.possuiLiminar === true ? 'linear-gradient(135deg, #38a169, #2f855a)' : '#fff',
            color: paciente.possuiLiminar === true ? '#fff' : '#475569',
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'Inter, sans-serif',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
        >
          Sim
        </button>
        <button
          type="button"
          onClick={() => updatePaciente('possuiLiminar', false)}
          style={{
            padding: '10px 28px',
            borderRadius: 10,
            border: paciente.possuiLiminar === false ? 'none' : '1.5px solid #e2e8f0',
            background: paciente.possuiLiminar === false ? 'linear-gradient(135deg, #e53e3e, #c53030)' : '#fff',
            color: paciente.possuiLiminar === false ? '#fff' : '#475569',
            fontSize: 14,
            fontWeight: 600,
            fontFamily: 'Inter, sans-serif',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
        >
          Não
        </button>
      </div>

      <label style={styles.label}>
        Tipo de Ocorrência<span style={styles.labelRequired}>*</span>
      </label>
      <select
        value={paciente.tipoOcorrencia}
        onChange={(e) => {
          updatePaciente('tipoOcorrencia', e.target.value);
          if (e.target.value !== 'Implantação') updatePaciente('tipo', '');
        }}
        onFocus={() => setFocusedField('tipoOcorrencia')}
        onBlur={() => setFocusedField(null)}
        style={getSelectStyle('tipoOcorrencia')}
      >
        <option value="">Selecione o tipo de ocorrência</option>
        {TIPO_OCORRENCIA_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>
      {errors.tipoOcorrencia && <div style={styles.errorMsg}>Campo obrigatório</div>}

      {paciente.tipoOcorrencia === 'Implantação' && (
        <>
          <label style={styles.label}>
            Modo de Entrada<span style={styles.labelRequired}>*</span>
          </label>
          <select
            value={paciente.tipo}
            onChange={(e) => updatePaciente('tipo', e.target.value)}
            onFocus={() => setFocusedField('tipo')}
            onBlur={() => setFocusedField(null)}
            style={getSelectStyle('tipo')}
          >
            <option value="">Selecione o modo de entrada</option>
            {TIPO_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
          {errors.tipo && <div style={styles.errorMsg}>Campo obrigatório</div>}
        </>
      )}

      <label style={styles.label}>Observações</label>
      <textarea
        value={paciente.observacoes}
        onChange={(e) => updatePaciente('observacoes', e.target.value)}
        onFocus={() => setFocusedField('observacoes')}
        onBlur={() => setFocusedField(null)}
        placeholder="Observações adicionais (opcional)"
        style={{
          ...styles.textarea,
          ...(focusedField === 'observacoes' ? styles.inputFocused : {}),
        }}
      />
    </div>
  );

  // ─── Render Screen 2: PAD ────────────────────────────────────────────────────
  const renderScreen2 = () => (
    <div>
      <p style={{ fontSize: 14, color: '#718096', marginTop: 0, marginBottom: 20, lineHeight: 1.6 }}>
        Ative as disciplinas que devem ser incluídas no Plano de Atenção Domiciliar e descreva as orientações para cada uma.
      </p>
      {PAD_DISCIPLINES.map((discipline) => (
        <div key={discipline.key} style={styles.disciplineCard}>
          <ToggleSwitch
            value={pad[discipline.key].enabled}
            onChange={(val) => updatePad(discipline.key, 'enabled', val)}
            label={`${discipline.label} (${discipline.short})`}
          />
          {pad[discipline.key].enabled && (
            <div style={{ marginTop: 12, display: 'grid', gridTemplateColumns: PAD_SUBESPECIALIDADES[discipline.key] ? '1fr 1fr' : '1fr', gap: 10 }}>
              {PAD_SUBESPECIALIDADES[discipline.key] && (
                <div>
                  <label style={{ ...styles.label, marginTop: 4, fontSize: 12, color: '#718096' }}>Sub-especialidade</label>
                  <select
                    value={pad[discipline.key].subEspecialidade}
                    onChange={(e) => updatePad(discipline.key, 'subEspecialidade', e.target.value)}
                    style={{ ...styles.select, fontSize: 13, padding: '9px 32px 9px 12px' }}
                  >
                    <option value="">— Selecione —</option>
                    {PAD_SUBESPECIALIDADES[discipline.key].map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>
              )}
              <div>
                <label style={{ ...styles.label, marginTop: 4, fontSize: 12, color: '#718096' }}>Frequência</label>
                <select
                  value={pad[discipline.key].frequencia}
                  onChange={(e) => updatePad(discipline.key, 'frequencia', e.target.value)}
                  style={{ ...styles.select, fontSize: 13, padding: '9px 32px 9px 12px' }}
                >
                  <option value="">— Selecione a frequência —</option>
                  {FREQUENCIA_OPTIONS.map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );

  // ─── Render Screens 3-10: Area Screens ───────────────────────────────────────
  const renderAreaScreen = (areaKey) => {
    const areaData = areas[areaKey];
    const screenInfo = SCREENS.find((s) => s.key === areaKey);
    return (
      <div>
        <p style={{ fontSize: 14, color: '#718096', marginTop: 0, marginBottom: 20, lineHeight: 1.6 }}>
          Ative esta área se ela faz parte desta ocorrência. Os campos abaixo são exemplos e podem ser personalizados.
        </p>

        <ToggleSwitch
          value={areaData.enabled}
          onChange={(val) => updateArea(areaKey, 'enabled', val)}
          label={`Incluir ${screenInfo.label}`}
        />

        {areaData.enabled && (
          <div style={{ marginTop: 16 }}>
            <label style={styles.pinkLabel}>Campo exemplo 1</label>
            <input
              type="text"
              value={areaData.campo1}
              onChange={(e) => updateArea(areaKey, 'campo1', e.target.value)}
              placeholder="Preencha este campo..."
              style={styles.input}
            />

            <label style={styles.pinkLabel}>Campo exemplo 2</label>
            <input
              type="text"
              value={areaData.campo2}
              onChange={(e) => updateArea(areaKey, 'campo2', e.target.value)}
              placeholder="Preencha este campo..."
              style={styles.input}
            />

            <label style={styles.pinkLabel}>Campo exemplo 3</label>
            <input
              type="text"
              value={areaData.campo3}
              onChange={(e) => updateArea(areaKey, 'campo3', e.target.value)}
              placeholder="Preencha este campo..."
              style={styles.input}
            />

            <label style={styles.label}>Observações</label>
            <textarea
              value={areaData.observacoes}
              onChange={(e) => updateArea(areaKey, 'observacoes', e.target.value)}
              placeholder="Observações para esta área (opcional)"
              style={styles.textarea}
            />
          </div>
        )}
      </div>
    );
  };

  // ─── Render Screen: Prontuário (campos específicos) ─────────────────────────
  const renderProntuarioScreen = () => {
    const d = areas.prontuario;
    const ITENS = [
      { key: 'pastaFixa',        label: 'Pasta Fixa',                 desc: 'Kit de documentos permanentes no domicílio' },
      { key: 'guiaAutorizacao',  label: 'Guia / Autorização',         desc: 'Solicitação e aprovação junto ao convênio' },
      { key: 'prescricaoMedica', label: 'Prescrição Médica',          desc: 'Receitas e prescrições médicas para o período' },
      { key: 'tcle',             label: 'TCLE',                       desc: 'Termo de Consentimento Livre e Esclarecido' },
      { key: 'cronograma',       label: 'Cronograma de Visitas',      desc: 'Planejamento das visitas por especialidade' },
      { key: 'admissao',         label: 'Admissão / Alta Hospitalar', desc: 'Documentação de transição hospital → domicílio' },
    ];
    return (
      <div>
        <p style={{ fontSize: 14, color: '#718096', marginTop: 0, marginBottom: 20, lineHeight: 1.6 }}>
          Ative o Prontuário e selecione quais itens precisam ser providenciados para esta ocorrência.
          Cada item marcado vira uma tarefa individual rastreável.
        </p>
        <ToggleSwitch
          value={d.enabled}
          onChange={(val) => updateArea('prontuario', 'enabled', val)}
          label="Incluir Prontuário nesta ocorrência"
        />
        {d.enabled && (
          <div style={{ marginTop: 18 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#4a5568', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Itens a providenciar
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {ITENS.map(({ key, label, desc }) => {
                const checked = !!d[key];
                return (
                  <div
                    key={key}
                    onClick={() => updateArea('prontuario', key, !checked)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 14, padding: '12px 14px',
                      borderRadius: 10, cursor: 'pointer',
                      border: `1.5px solid ${checked ? '#319795' : '#e2e8f0'}`,
                      background: checked ? '#e6fffa' : '#f7fafc',
                      transition: 'all 0.15s',
                    }}
                  >
                    <div style={{
                      width: 20, height: 20, borderRadius: 5, border: `2px solid ${checked ? '#319795' : '#cbd5e0'}`,
                      background: checked ? '#319795' : '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0, transition: 'all 0.15s',
                    }}>
                      {checked && <span style={{ color: '#fff', fontSize: 12, fontWeight: 700 }}>✓</span>}
                    </div>
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: checked ? '#2c7a7b' : '#2d3748' }}>{label}</div>
                      <div style={{ fontSize: 12, color: '#718096', marginTop: 2 }}>{desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            <label style={styles.label}>Observações</label>
            <textarea
              value={d.observacoes}
              onChange={(e) => updateArea('prontuario', 'observacoes', e.target.value)}
              placeholder="Informações adicionais para o time de Prontuário (opcional)"
              style={styles.textarea}
            />
          </div>
        )}
      </div>
    );
  };

  // ─── Screen Router ───────────────────────────────────────────────────────────
  const renderCurrentScreen = () => {
    if (currentScreen === 0) return renderScreen1();
    if (currentScreen === 1) return renderScreen2();
    const areaKey = AREA_SCREENS_KEYS[currentScreen - 2];
    if (areaKey === 'prontuario') return renderProntuarioScreen();
    if (areaKey) return renderAreaScreen(areaKey);
    return null;
  };

  // ─── Progress Dots ───────────────────────────────────────────────────────────
  const renderDots = () => (
    <div style={styles.dots}>
      {SCREENS.map((_, idx) => (
        <div
          key={idx}
          onClick={() => {
            if (idx < currentScreen) navigateTo(idx);
            if (idx > currentScreen && currentScreen === 0 && !validateScreen1()) return;
            if (idx > currentScreen) navigateTo(idx);
          }}
          style={{
            width: idx === currentScreen ? 24 : 10,
            height: 10,
            borderRadius: 5,
            background: idx === currentScreen
              ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              : idx < currentScreen
                ? '#a0aec0'
                : '#e2e8f0',
            cursor: 'pointer',
            transition: 'all 0.25s ease',
          }}
        />
      ))}
    </div>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.65)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ ...styles.card, maxHeight: '90vh', display: 'flex', flexDirection: 'column', position: 'relative' }}>

        {/* Gradient Header */}
        <div style={{ ...styles.headerBar, paddingRight: 52, flexShrink: 0 }}>
          <div style={styles.headerSubtitle}>
            Tela {currentScreen + 1} de {SCREENS.length} — {screen.label}
          </div>
          <h2 style={styles.headerTitle}>
            {currentScreen === 0 ? 'Nova Ocorrência' : screen.label}
          </h2>
        </div>

        {/* Close button */}
        <button
          onClick={() => { if (onClose) onClose(); else window.location.href = '/gestao-ocorrencias'; }}
          style={{ position: 'absolute', top: 14, right: 16, background: 'rgba(255,255,255,0.18)', border: 'none', borderRadius: 8, color: '#fff', fontSize: 16, fontWeight: 700, cursor: 'pointer', padding: '4px 10px', lineHeight: 1 }}
        >✕</button>

        {/* Body - scrollable */}
        <div style={{ ...styles.body, flex: 1, overflowY: 'auto' }}>
          {renderCurrentScreen()}
        </div>

        {/* Bottom Navigation Bar */}
        <div style={styles.bottomBar}>
          <button
            type="button"
            onClick={handleBack}
            style={styles.btnBack}
            onMouseEnter={(e) => { e.currentTarget.style.background = '#f7fafc'; e.currentTarget.style.borderColor = '#cbd5e0'; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
          >
            ← Voltar
          </button>

          {renderDots()}

          {isLastScreen ? (
            <button
              type="button"
              onClick={handleSubmit}
              disabled={submitting}
              style={styles.btnSubmit}
              onMouseEnter={(e) => { if (!submitting) e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              {submitting ? 'Criando...' : 'Abrir Ocorrência'}
            </button>
          ) : (
            <button
              type="button"
              onClick={handleNext}
              style={styles.btnNext}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              Seguir →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
